import { QueryClient } from '@tanstack/angular-query-experimental';

/**
 * The app's single TanStack Query cache.
 *
 * - Cached data shows at once when a page opens again; it is checked against the server in the background when
 *   older than `staleTime` (on open, on window focus, on reconnect). The server answers such checks with a 304
 *   when nothing changed, so they cost almost nothing.
 * - Any write the app sends marks the whole cache as stale (see {@link invalidateOnWriteInterceptor}), and logging
 *   out empties it: data never outlives a change made here, nor the session that loaded it.
 * - Unused data is dropped after `gcTime`.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        gcTime: 30 * 60_000,
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
    },
  });
}
